import en_US from './en_US.json';
import es_MX from './es_MX.json';
import es_CO from './es_CO.json';
import es_EC from './es_EC.json';
import es_PA from './es_PA.json';
import es_PE from './es_PE.json';
import pt_BR from './pt_BR.json';
import id_ID from './id_ID.json';
import ceb_PH from './ceb_PH.json';
import tl_PH from './tl_PH.json';

export type TranslationKey =
    | 'LIVENESS_COACHING_TITLE'
    | 'LIVENESS_COACHING_TIP_INDOOR'
    | 'LIVENESS_COACHING_TIP_SUNLIGHT'
    | 'LIVENESS_COACHING_TIP_BRIGHTNESS'
    | 'LIVENESS_V2_PHOTOSENSITIVITY_TITLE'
    | 'LIVENESS_V2_PHOTOSENSITIVITY_BODY'
    | 'LIVENESS_V2_START_BUTTON'
    | 'LIVENESS_V2_CAMERA_PERMISSION_TITLE'
    | 'LIVENESS_V2_CAMERA_PERMISSION_IDENTITY'
    | 'LIVENESS_V2_CAMERA_PERMISSION_SIGNATURE'
    | 'LIVENESS_V2_CAMERA_PERMISSION_BUTTON'
    | 'LIVENESS_V2_CAMERA_BLOCKED_TITLE'
    | 'LIVENESS_V2_CAMERA_BLOCKED_BODY'
    | 'LIVENESS_V2_CAMERA_BLOCKED_STEP_ONE'
    | 'LIVENESS_V2_CAMERA_BLOCKED_STEP_TWO'
    | 'LIVENESS_V2_CAMERA_BLOCKED_STEP_THREE'
    | 'LIVENESS_V2_CAMERA_BLOCKED_STEP_FOUR'
    | 'LIVENESS_V2_CAMERA_BLOCKED_BUTTON'
    | IncodeV2Key;

// V2 keys are optional per locale so a rollout doesn't require translating
// all 10 locales up front — useTranslation() falls back to en_US when missing.
type CoachingKey =
    | 'LIVENESS_COACHING_TITLE'
    | 'LIVENESS_COACHING_TIP_INDOOR'
    | 'LIVENESS_COACHING_TIP_SUNLIGHT'
    | 'LIVENESS_COACHING_TIP_BRIGHTNESS';
type V2Key =
    | 'LIVENESS_V2_PHOTOSENSITIVITY_TITLE'
    | 'LIVENESS_V2_PHOTOSENSITIVITY_BODY'
    | 'LIVENESS_V2_START_BUTTON'
    | 'LIVENESS_V2_CAMERA_PERMISSION_TITLE'
    | 'LIVENESS_V2_CAMERA_PERMISSION_IDENTITY'
    | 'LIVENESS_V2_CAMERA_PERMISSION_SIGNATURE'
    | 'LIVENESS_V2_CAMERA_PERMISSION_BUTTON'
    | 'LIVENESS_V2_CAMERA_BLOCKED_TITLE'
    | 'LIVENESS_V2_CAMERA_BLOCKED_BODY'
    | 'LIVENESS_V2_CAMERA_BLOCKED_STEP_ONE'
    | 'LIVENESS_V2_CAMERA_BLOCKED_STEP_TWO'
    | 'LIVENESS_V2_CAMERA_BLOCKED_STEP_THREE'
    | 'LIVENESS_V2_CAMERA_BLOCKED_STEP_FOUR'
    | 'LIVENESS_V2_CAMERA_BLOCKED_BUTTON'
    | IncodeV2Key;

// Incode-V2-specific screens (boot, tutorial, learn-more, spinners, terminal
// errors). Optional per locale — falls back to en_US when a locale omits them.
type IncodeV2Key =
    | 'LIVENESS_V2_INCODE_BOOT_ERROR_TITLE'
    | 'LIVENESS_V2_INCODE_BOOT_ERROR_BODY'
    | 'LIVENESS_V2_INCODE_LOADING'
    | 'LIVENESS_V2_INCODE_TUTORIAL_TITLE'
    | 'LIVENESS_V2_INCODE_TUTORIAL_BODY'
    | 'LIVENESS_V2_INCODE_TUTORIAL_BUTTON'
    | 'LIVENESS_V2_INCODE_LEARN_MORE_TITLE'
    | 'LIVENESS_V2_INCODE_LEARN_MORE_BODY'
    | 'LIVENESS_V2_INCODE_LEARN_MORE_BUTTON'
    | 'LIVENESS_V2_INCODE_PERMISSION_WAITING'
    | 'LIVENESS_V2_INCODE_PROCESSING'
    | 'LIVENESS_V2_INCODE_TRY_AGAIN'
    | 'LIVENESS_V2_INCODE_ERROR_NOT_RECOGNIZED_TITLE'
    | 'LIVENESS_V2_INCODE_ERROR_NOT_RECOGNIZED_BODY'
    | 'LIVENESS_V2_INCODE_ERROR_SPOOF_TITLE'
    | 'LIVENESS_V2_INCODE_ERROR_SPOOF_BODY'
    | 'LIVENESS_V2_INCODE_ERROR_NO_ATTEMPTS_TITLE'
    | 'LIVENESS_V2_INCODE_ERROR_NO_ATTEMPTS_BODY'
    | 'LIVENESS_V2_INCODE_ERROR_NO_CUSTOMER_TITLE'
    | 'LIVENESS_V2_INCODE_ERROR_NO_CUSTOMER_BODY'
    | 'LIVENESS_V2_INCODE_ERROR_HINT_MISSING_TITLE'
    | 'LIVENESS_V2_INCODE_ERROR_HINT_MISSING_BODY'
    | 'LIVENESS_V2_INCODE_ERROR_DEFAULT_TITLE'
    | 'LIVENESS_V2_INCODE_ERROR_DEFAULT_BODY'
    | 'LIVENESS_V2_INCODE_CAMERA_BLOCKED_TITLE'
    | 'LIVENESS_V2_INCODE_CAMERA_BLOCKED_BODY'
    | 'LIVENESS_V2_INCODE_CAMERA_BLOCKED_BUTTON'
    | 'LIVENESS_V2_INCODE_GUIDANCE_IDLE'
    | 'LIVENESS_V2_INCODE_GUIDANCE_DETECTING'
    | 'LIVENESS_V2_INCODE_GUIDANCE_NO_FACE'
    | 'LIVENESS_V2_INCODE_GUIDANCE_TOO_MANY_FACES'
    | 'LIVENESS_V2_INCODE_GUIDANCE_TOO_CLOSE'
    | 'LIVENESS_V2_INCODE_GUIDANCE_TOO_FAR'
    | 'LIVENESS_V2_INCODE_GUIDANCE_BLUR'
    | 'LIVENESS_V2_INCODE_GUIDANCE_DARK'
    | 'LIVENESS_V2_INCODE_GUIDANCE_TOO_BRIGHT'
    | 'LIVENESS_V2_INCODE_GUIDANCE_FACE_ANGLE'
    | 'LIVENESS_V2_INCODE_GUIDANCE_LOOK_AT_CAMERA'
    | 'LIVENESS_V2_INCODE_GUIDANCE_HEAD_WEAR'
    | 'LIVENESS_V2_INCODE_GUIDANCE_LENSES'
    | 'LIVENESS_V2_INCODE_GUIDANCE_EYES_CLOSED'
    | 'LIVENESS_V2_INCODE_GUIDANCE_FACE_MASK'
    | 'LIVENESS_V2_INCODE_GUIDANCE_FACE_OCCLUSION'
    | 'LIVENESS_V2_INCODE_GUIDANCE_CENTER_FACE'
    | 'LIVENESS_V2_INCODE_GUIDANCE_MOVE_LEFT'
    | 'LIVENESS_V2_INCODE_GUIDANCE_MOVE_RIGHT'
    | 'LIVENESS_V2_INCODE_GUIDANCE_MANUAL_CAPTURE'
    | 'LIVENESS_V2_INCODE_GUIDANCE_GET_READY'
    | 'LIVENESS_V2_INCODE_GUIDANCE_GET_READY_FINISHED'
    | 'LIVENESS_V2_INCODE_GUIDANCE_CAPTURING'
    | 'LIVENESS_V2_INCODE_GUIDANCE_SUCCESS'
    | 'LIVENESS_V2_INCODE_GUIDANCE_OFFLINE'
    | 'LIVENESS_V2_INCODE_GUIDANCE_ERROR'
    | 'LIVENESS_V2_INCODE_GUIDANCE_DEFAULT';

export type Translations = Record<CoachingKey, string> & Partial<Record<V2Key | IncodeV2Key, string>>;

const locales: Record<string, Translations> = {
    en_US,
    es_MX,
    es_CO,
    es_EC,
    es_PA,
    es_PE,
    pt_BR,
    id_ID,
    ceb_PH,
    tl_PH,
};

export default locales;
